import actionTypes from '../constants/action-types';

const error = (state = null, action) => {
  if (action.type !== actionTypes.SET_ERROR) {
    return state;
  }
  return action.payload.error;
};

export default error;
